import apiClient from './api';
import { API_CONFIG } from '../utils/constants';
import { EstadoSucursal } from '../models/EstadoSucursal';

export class EstadoSucursalService {
  
  // Obtener todos los estados de sucursal
  static async getAllEs(id) {
    try {
      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.ESTADOSUCURSAL}/sucursal/${id}`);
      
      // ✅ MANEJO ESPECÍFICO PARA TU FORMATO DE API
      let Data;
      if (response.data.success && response.data.data) {
        Data = response.data.data; // Tu formato: {success: true, data: [...]}
      } else if (Array.isArray(response.data)) {
        Data = response.data; // Formato directo: [...]
      } else {
        throw new Error('Formato de datos incorrecto del servidor');
      }
      
      if (!Array.isArray(Data)) {
        throw new Error('Los datos recibidos no son un array');
      }
      
      // ✅ MAPEAR CADA ESTADO
      const mapped = Data.map((rData) => {
        return new EstadoSucursal(rData);
      });
      
      return mapped;
      
    } catch (error) {
      console.error('❌ === ERROR GETALL ESTADO SUCURSAL ===');
      console.error('❌ Error completo:', error);
      console.error('❌ Error response:', error.response);
      console.error('❌ Error message:', error.message);
      
      if (error.response) {
        console.error('❌ Status:', error.response.status);
        console.error('❌ Status Text:', error.response.statusText);
        console.error('❌ Data:', error.response.data);
      }
      
      throw new Error('Error al obtener EstadoSucursal: ' + error.message);
    }
  }

  // Obtener estado de sucursal por ID
  static async getById(id) {
    try {
      console.log('🔄 Cargando estado de sucursal ID:', id);
      const response = await apiClient.get(`${API_CONFIG.ENDPOINTS.ESTADOSUCURSAL}/sucursal/${id}`);
      
      console.log('✅ EstadoSucursal obtenido:', response.data);
      
      // ✅ CORRECCIÓN: El API devuelve { success: true, data: [...] }
      // Necesitamos extraer el primer elemento del array
      let estadoData;
      
      if (response.data.success && response.data.data) {
        // Caso 1: Formato {success: true, data: [...]}, tomar el primer elemento
        if (Array.isArray(response.data.data) && response.data.data.length > 0) {
          estadoData = response.data.data[0];
          console.log('✅ Extrayendo primer elemento del array:', estadoData);
        } else {
          console.warn('⚠️ data es un array vacío');
          return null;
        }
      } else if (Array.isArray(response.data)) {
        // Caso 2: Formato directo [...], tomar el primer elemento
        if (response.data.length > 0) {
          estadoData = response.data[0];
        } else {
          console.warn('⚠️ Array de respuesta vacío');
          return null;
        }
      } else if (response.data.estado) {
        // Caso 3: Ya es un objeto directamente
        estadoData = response.data;
      } else {
        console.warn('⚠️ Formato de respuesta no reconocido');
        return null;
      }
      
      // ✅ Retornar el objeto completo del API SIN crear instancia de EstadoSucursal
      // Ya que solo necesitamos leer el estado, no modificarlo
      return estadoData;
      
    } catch (error) {
      console.error('❌ Error obteniendo EstadoSucursal:', error);
      throw new Error('Error al obtener el EstadoSucursal');
    }
  }

  // Crear nuevo estado de sucursal
  static async create(Data) {
    try {
      console.log('🔍 Datos recibidos para crear:', Data);
      
      // ✅ Crear la instancia de EstadoSucursal
      const estadoSucursal = new EstadoSucursal(Data);
      const dataToSend = estadoSucursal.toCreateFormat();
      
      console.log('🔍 Creando EstadoSucursal con formato:', dataToSend);
      
      const response = await apiClient.post(API_CONFIG.ENDPOINTS.ESTADOSUCURSAL, dataToSend);
      console.log('✅ EstadoSucursal creado:', response.data);
      
      return response.data;
      
    } catch (error) {
      console.error('❌ Error creando EstadoSucursal:', error);
      console.error('❌ Error response:', error.response?.data);
      throw new Error('Error al crear el EstadoSucursal: ' + (error.response?.data?.message || error.message));
    }
  }

  // MÉTODO DE PRUEBA
  static async testConnection() {
    try {
      console.log('🧪 === TEST CONNECTION ===');
      console.log('🧪 URL Base:', API_CONFIG.BASE_URL);
      console.log('🧪 Endpoint:', API_CONFIG.ENDPOINTS.ESTADOSUCURSAL);
      console.log('🧪 URL Completa:', API_CONFIG.BASE_URL + API_CONFIG.ENDPOINTS.ESTADOSUCURSAL);
      
      const response = await apiClient.get(API_CONFIG.ENDPOINTS.ESTADOSUCURSAL);
      console.log('✅ ¡CONEXIÓN EXITOSA!');
      console.log('✅ Response completo:', response);
      console.log('✅ Response data:', response.data);
      
      return response;
    } catch (error) {
      console.error('❌ FALLO EN LA CONEXIÓN:', error);
      console.error('❌ Error response:', error.response);
      return error;
    }
  }
}